import { adminReducer } from 'react-admin';

import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

// import custom reducers

export default function createReducer(history) {
  return combineReducers({
    admin: adminReducer,
    router: connectRouter(history),
  });
}
